// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"8e4555e7","286":"c11c6d6c","488":"3de03163"}[chunkId] + ".chunk.js";
};